import L from 'leaflet';
import { TimedGroup, CapabilityMergeStrategy } from './TimedGroup';
import moment from 'moment-timezone';

export interface WMSServer {
  url: string;
  capabilityId?: string;
  subdomains?: string;
}

export interface MapLayer {
  key: string;
  server: WMSServer;
  attribution?: string;
}

export const NORDIC_BOUNDS = L.latLngBounds([30, -40], [80, 60]);

export const SWEDEN_BOUNDS = (() => {
  const northEast = L.latLng(69, 24);
  const southWest = L.latLng(55, 11);
  return L.latLngBounds(southWest, northEast);
})();

export const SEAICE_CENTER = L.latLng(62.9, 20.8);

export const WORLD_BOUNDS = L.latLngBounds([-90, -180], [90, 180]);

export const GEO_WEB_CACHE_LAYERS = {
  OSM_WORLD: 'osm:openstreetmap_world_900913_SMHI',
  OSM_BACKGROUND: 'osm:openstreetmap-background_world_900913_SMHI',
  OSM_ROADS: 'osm:openstreetmap-rr_world_900913_SMHI',
  OSM_CITIES: 'osm:openstreetmap-cities_world_900913_SMHI',
  EDM_COUNTRYBORDERS_WORLD: 'edm:countryborders_world_4326_bw',
  GSD_LARGE_LAKES_SWEDEN: 'gsd:large-lakes_sweden_3021_transp::2011-05-11',
};

export const PICASSO_SERVER: WMSServer = {
  url: 'https://wts{s}.smhi.se/tile/?',
  capabilityId: 'picasso',
  subdomains: '1234',
};

export const GEO_WEB_CHACHE_SERVER: WMSServer = {
  url: 'https://wts{s}.smhi.se/geowebcache/service/wms/?',
  subdomains: '1234',
};

export const MOM_SERVER: WMSServer = {
  url: 'https://wts{s}.smhi.se/mom.map?',
  capabilityId: 'mapserver',
  subdomains: '1234',
};

export const MAP_PROXY: WMSServer = {
  url: 'https://wts{s}.smhi.se/mapproxy/service?',
  subdomains: '1234',
};

export const OSM_ATTRIBUTION =
  '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';

export const LAYERS = {
  OSM_BACKGROUND_SWEDEN: {
    key: 'osm:openstreetmap-background_sweden_900913_wpt',
    server: MOM_SERVER,
    attribution: OSM_ATTRIBUTION,
  },
  OSM_LABELS_SWEDEN: {
    key: 'osm:labels_sweden_900913_a',
    server: MAP_PROXY,
    attribution: OSM_ATTRIBUTION,
  },
  OSM_ROADS_SWEDEN: {
    key: 'osm:openstreetmap-rr_sweden_900913_SMHI::2011-05-13',
    server: MOM_SERVER,
    attribution: OSM_ATTRIBUTION,
  },
  SEAICE_TYPE: { key: 'smhi:seaice-type_baltic_4326_', server: MOM_SERVER },
  SEAICE_THICKNESS: {
    key: 'smhi:seaice-icetck_baltic_4326_',
    server: MOM_SERVER,
  },
  SEAICE_SATELLITE_TEMPERATURE: {
    key: 'sat:polar-sst_euron1_9999_',
    server: MOM_SERVER,
  },
  SEAICE_SATELLITE_INFRARED: {
    key: 'sat:sar-fmi_baltic_3395_',
    server: MOM_SERVER,
  },
};

export const EPSG900913 = (L.CRS as any).EPSG900913; // exists in runtime not in type system

export const MAX_ZOOM = 10;
export const MIN_ZOOM = 4;

export const SEAICE_GROUPS: TimedGroup[] = [
  {
    key: 'seaIceType',
    layers: [LAYERS.SEAICE_TYPE],
    strategy: CapabilityMergeStrategy.UseFirst,
    timeBounds: {
      min: moment.duration(-10, 'days'),
    },
  },
  {
    key: 'seaIceThickness',
    layers: [LAYERS.SEAICE_THICKNESS],
    strategy: CapabilityMergeStrategy.UseFirst,
    timeBounds: {
      min: moment.duration(-10, 'days'),
    },
  },
];

export const SATELLITE_GROUPS: TimedGroup[] = [
  {
    key: 'ice',
    layers: [LAYERS.SEAICE_SATELLITE_INFRARED],
    strategy: CapabilityMergeStrategy.UseFirst,
    timeBounds: {
      min: moment.duration(-4, 'days'),
    },
  },
  {
    key: 'surfaceTemperature',
    layers: [LAYERS.SEAICE_SATELLITE_TEMPERATURE],
    strategy: CapabilityMergeStrategy.UseFirst,
    timeBounds: {
      min: moment.duration(-10, 'days'),
    },
  },
];
